$(document).ready(function(){
// !function(a){"use strict";a.ajaxChimp={responses:{"We have sent you a confirmation email":0,"Please enter a value":1,"An email address must contain a single @":2,"The domain portion of the email address is invalid (the portion after the @: )":3,"The username portion of the email address is invalid (the portion before the @: )":4,"This email address looks fake or invalid. Please enter a real email address":5},translations:{en:null},init:function(e,s){a(e).ajaxChimp(s)}},a.fn.ajaxChimp=function(e){return a(this).each(function(s,n){var i=a(n),t=i.find("input[type=email]"),r=i.find("label[for="+t.attr("id")+"]"),l=a.extend({url:i.attr("action"),language:"en"},e),o=l.url.replace("/post?","/post-json?").concat("&c=?");i.attr("novalidate","true"),t.attr("name","EMAIL"),i.submit(function(){var e;var s={},n=i.serializeArray();a.each(n,function(a,e){s[e.name]=e.value}),a.ajax({url:o,data:s,success:function(s){if("success"===s.result)e="We have sent you a confirmation email",r.removeClass("error").addClass("valid"),t.removeClass("error").addClass("valid");else{t.removeClass("valid").addClass("error"),r.removeClass("valid").addClass("error");try{var n=s.msg.split(" - ",2);void 0===n[1]?e=s.msg:parseInt(n[0],10).toString()===n[0]?(n[0],e=n[1]):e=s.msg}catch(a){e=s.msg}}"en"!==l.language&&void 0!==a.ajaxChimp.responses[e]&&a.ajaxChimp.translations&&a.ajaxChimp.translations[l.language]&&a.ajaxChimp.translations[l.language][a.ajaxChimp.responses[e]]&&(e=a.ajaxChimp.translations[l.language][a.ajaxChimp.responses[e]]),r.html(e),r.show(2e3),l.callback&&l.callback(s)},dataType:"jsonp",error:function(a,e){console.log("mailchimp ajax submit error: "+e)}});var m="Submitting...";return"en"!==l.language&&a.ajaxChimp.translations&&a.ajaxChimp.translations[l.language]&&a.ajaxChimp.translations[l.language].submit&&(m=a.ajaxChimp.translations[l.language].submit),r.html(m).show(2e3),!1})}),this}}(jQuery); 
 var pageURL = $(location).attr("href").split('pages/');
	console.log(pageURL[1]);
var list = [];
var skin_arr = { 
   dryacc_black :  'rosequartz', 
   drysm_wrink :   'rosequartz', 
   drydeep_wrink : 'amethyst', 
   drysag_puff :   'clearquartz', 
   dryirr_itchi :  'amethyst', 
   dryna :        'amethyst', 
   oilyacc_black :  'jade', 
   oilysm_wrink :   'rosequartz', 
   oilydeep_wrink : 'clearquartz', 
   oilysag_puff :   'tourmaline', 
   oilyirr_itchi :  'jade', 
   oilyna :        'jade',
   combinationacc_black :  'jade', 
   combinationsm_wrink :   'rosequartz', 
   combinationdeep_wrink : 'amethyst', 
   combinationsag_puff :   'tourmaline', 
   combinationirr_itchi :  'rosequartz', 
   combinationna :        'rosequartz', 
   normalacc_black :  'rosequartz', 
   normalsm_wrink :   'rosequartz', 
   normaldeep_wrink : 'amethyst', 
   normalsag_puff :   'tourmaline', 
   normalirr_itchi :  'rosequartz', 
   normalna :        'clearquartz', 
   sensitiveacc_black :  'rosequartz', 
   sensitivesm_wrink :   'rosequartz', 
   sensitivedeep_wrink : 'amethyst', 
   sensitivesag_puff :   'tourmaline', 
   sensitiveirr_itchi :  'rosequartz', 
   sensitivena :         'rosequartz', 
   
};
var acupuncture_arr = { 
    oliycrack_tongueweak_knees: 'clearquartz', 
    oliycrack_tonguedig_dis: 'jade',
    oliycrack_tonguefeel_pain: 'jade',
    oliycrack_tongueanxit_pal: 'rosequartz',
    oliycrack_tonguena: 'jade',
    oliyred_circleweak_knees: 'rosequartz',
    oliyred_circledig_dis: 'jade',
    oliyred_circlefeel_pain: 'jade',
    oliyred_circleanxit_pal: 'rosequartz',
    oliyred_circlena: 'jade',
    oliysmth_mirrweak_knees: 'clearquartz',
    oliysmth_mirrdig_dis: 'jade',
    oliysmth_mirrfeel_pain: 'jade',
    oliysmth_mirranxit_pal:  'rosequartz',
    oliysmth_mirrna: 'jade',
    oliythick_whiteweak_knees: 'jade',
    oliythick_whitedig_dis: 'tourmaline',
    oliythick_whitefeel_pain: 'jade',
    oliythick_whiteanxit_pal: 'jade',
    oliythick_whitena:'jade',
    oliyteeth_markweak_knees: 'jade',
    oliyteeth_markdig_dis: 'tourmaline',
    oliyteeth_markfeel_pain: 'jade',
    oliyteeth_markanxit_pal:  'jade',
    oliyteeth_markna:  'jade',
    oliynaweak_knees: 'clearquartz',
    oliynadig_dis:  'jade',
    oliynafeel_pain: 'jade',
    oliynaanxit_pal: 'jade',
    oliynana: 'jade',
  	puffycrack_tongueweak_knees: 'amethyst', 
    puffycrack_tonguedig_dis: 'tourmaline',
    puffycrack_tonguefeel_pain: 'jade',
    puffycrack_tongueanxit_pal: 'rosequartz',
    puffycrack_tonguena: 'tourmaline',
    puffyred_circleweak_knees: 'clearquartz',
    puffyred_circledig_dis: 'tourmaline',
    puffyred_circlefeel_pain: 'jade',
    puffyred_circleanxit_pal: 'rosequartz',
    puffyred_circlena: 'tourmaline',
    puffysmth_mirrweak_knees: 'clearquartz',
    puffysmth_mirrdig_dis: 'tourmaline',
    puffysmth_mirrfeel_pain: 'jade',
    puffysmth_mirranxit_pal:  'rosequartz',
    puffysmth_mirrna: 'tourmaline',
    puffythick_whiteweak_knees: 'tourmaline',
    puffythick_whitedig_dis: 'tourmaline',
    puffythick_whitefeel_pain: 'jade',
    puffythick_whiteanxit_pal: 'jade',
    puffythick_whitena:'tourmaline',
    puffyteeth_markweak_knees: 'clearquartz',
    puffyteeth_markdig_dis: 'tourmaline',
    puffyteeth_markfeel_pain: 'jade',
    puffyteeth_markanxit_pal:  'rosequartz',
    puffyteeth_markna:  'tourmaline',
    puffynaweak_knees: 'clearquartz',
    puffynadig_dis:  'tourmaline',
    puffynafeel_pain: 'jade',
    puffynaanxit_pal: 'rosequartz',
    puffynana: 'tourmaline',
    sm_wrinklescrack_tongueweak_knees: 'amethyst', 
    sm_wrinklescrack_tonguedig_dis: 'rosequartz',
    sm_wrinklescrack_tonguefeel_pain: 'rosequartz',
    sm_wrinklescrack_tongueanxit_pal: 'rosequartz',
    sm_wrinklescrack_tonguena: 'rosequartz',
    sm_wrinklesred_circleweak_knees: 'amethyst',
    sm_wrinklesred_circledig_dis: 'rosequartz',
    sm_wrinklesred_circlefeel_pain: 'rosequartz',
    sm_wrinklesred_circleanxit_pal: 'rosequartz',
    sm_wrinklesred_circlena: 'rosequartz',
    sm_wrinklessmth_mirrweak_knees: 'amethyst',
    sm_wrinklessmth_mirrdig_dis: 'rosequartz',
    sm_wrinklessmth_mirrfeel_pain: 'rosequartz',
    sm_wrinklessmth_mirranxit_pal:  'rosequartz',
    sm_wrinklessmth_mirrna: 'rosequartz',
    sm_wrinklesthick_whiteweak_knees: 'clearquartz',
    sm_wrinklesthick_whitedig_dis: 'tourmaline',
    sm_wrinklesthick_whitefeel_pain: 'jade',
    sm_wrinklesthick_whiteanxit_pal: 'clearquartz',
    sm_wrinklesthick_whitena:'clearquartz',
    sm_wrinklesteeth_markweak_knees: 'rosequartz',
    sm_wrinklesteeth_markdig_dis: 'rosequartz',
    sm_wrinklesteeth_markfeel_pain: 'rosequartz',
    sm_wrinklesteeth_markanxit_pal:  'rosequartz',
    sm_wrinklesteeth_markna:  'rosequartz',
    sm_wrinklesnaweak_knees: 'amethyst',
    sm_wrinklesnadig_dis:  'rosequartz',
    sm_wrinklesnafeel_pain: 'rosequartz',
    sm_wrinklesnaanxit_pal: 'rosequartz',
    sm_wrinklesnana: 'rosequartz',
	age_skincrack_tongueweak_knees: 'amethyst', 
    age_skincrack_tonguedig_dis: 'amethyst',
    age_skincrack_tonguefeel_pain: 'amethyst',
    age_skincrack_tongueanxit_pal: 'rosequartz',
    age_skincrack_tonguena: 'amethyst',
    age_skinred_circleweak_knees: 'amethyst',
    age_skinred_circledig_dis: 'amethyst',
    age_skinred_circlefeel_pain: 'amethyst',
    age_skinred_circleanxit_pal: 'clearquartz',
    age_skinred_circlena: 'amethyst',
    age_skinsmth_mirrweak_knees: 'amethyst',
    age_skinsmth_mirrdig_dis: 'amethyst',
    age_skinsmth_mirrfeel_pain: 'amethyst',
    age_skinsmth_mirranxit_pal:  'rosequartz',
    age_skinsmth_mirrna: 'amethyst',
    age_skinthick_whiteweak_knees: 'clearquartz',
    age_skinthick_whitedig_dis: 'tourmaline',
    age_skinthick_whitefeel_pain: 'jade',
    age_skinthick_whiteanxit_pal: 'clearquartz',
    age_skinthick_whitena:'amethyst',
    age_skinteeth_markweak_knees: 'amethyst',
	age_skinteeth_markdig_dis: 'clearquartz',
    age_skinteeth_markfeel_pain: 'clearquartz',
    age_skinteeth_markanxit_pal:  'rosequartz',
    age_skinteeth_markna:  'amethyst',
    age_skinnaweak_knees: 'amethyst',
    age_skinnadig_dis:  'amethyst',
    age_skinnafeel_pain: 'clearquartz',
    age_skinnaanxit_pal: 'rosequartz',
    age_skinnana: 'amethyst',
  	combinationcrack_tongueweak_knees: 'amethyst', 
    combinationcrack_tonguedig_dis: 'clearquartz',
    combinationcrack_tonguefeel_pain: 'jade',
    combinationcrack_tongueanxit_pal: 'rosequartz',
    combinationcrack_tonguena: 'clearquartz',
    combinationred_circleweak_knees: 'amethyst',
    combinationred_circledig_dis: 'rosequartz',
    combinationred_circlefeel_pain: 'jade',
    combinationred_circleanxit_pal: 'rosequartz',
    combinationred_circlena: 'rosequartz',
    combinationsmth_mirrweak_knees: 'clearquartz',
    combinationsmth_mirrdig_dis: 'clearquartz',
    combinationsmth_mirrfeel_pain: 'jade',
    combinationsmth_mirranxit_pal:  'rosequartz',
    combinationsmth_mirrna: 'clearquartz',
    combinationthick_whiteweak_knees: 'clearquartz',
    combinationthick_whitedig_dis: 'clearquartz',
    combinationthick_whitefeel_pain: 'jade',
    combinationthick_whiteanxit_pal: 'rosequartz',
    combinationthick_whitena:'clearquartz',
    combinationteeth_markweak_knees: 'clearquartz',
	combinationteeth_markdig_dis: 'clearquartz',
    combinationteeth_markfeel_pain: 'clearquartz',
    combinationteeth_markanxit_pal:  'rosequartz',
    combinationteeth_markna:  'clearquartz',
    combinationnaweak_knees: 'clearquartz',
    combinationnadig_dis:  'clearquartz',
    combinationnafeel_pain: 'clearquartz',
    combinationnaanxit_pal: 'rosequartz',
    combinationnana: 'clearquartz',
  	
}; 
var chak_arr = { 
   lackopenheart :  'rosequartz', 
   lackdeepconn :   'tourmaline', 
   lackinclarity :  'clearquartz', 
   lackdeep_puff :   'clearquartz', 
   lackgentnature :  'clearquartz', 
   inabilityopenheart :  'clearquartz', 
   inabilitydeepconn :   'tourmaline', 
   inabilityinclarity :  'clearquartz', 
   inabilitydeep_puff :   'clearquartz', 
   inabilitygentnature :  'clearquartz',
   loveopenheart :  'rosequartz', 
   lovedeepconn :   'clearquartz', 
   loveinclarity :  'clearquartz', 
   lovedeep_puff :   'clearquartz', 
   lovegentnature :  'clearquartz',
   concenopenheart :  'rosequartz', 
   concendeepconn :   'clearquartz', 
   conceninclarity :  'amethyst', 
   concendeep_puff :   'clearquartz', 
   concengentnature :  'clearquartz',
   anxopenheart :  'rosequartz', 
   anxdeepconn :   'clearquartz', 
   anxinclarity :  'amethyst', 
   anxdeep_puff :   'clearquartz', 
   anxgentnature :  'clearquartz',
   naopenheart :  'rosequartz', 
   nadeepconn :   'tourmaline', 
   nainclarity :  'amethyst', 
   nadeep_puff :   'jade', 
   nagentnature :  'clearquartz', 
}; 
var microneedling_arr = { 
   lackopenheart :  'rosequartz', 
   lackdeepconn :   'tourmaline', 
   lackinclarity :  'clearquartz', 
   lackdeep_puff :   'clearquartz', 
   lackgentnature :  'clearquartz', 
   inabilityopenheart :  'clearquartz', 
   inabilitydeepconn :   'tourmaline', 
   inabilityinclarity :  'clearquartz', 
   inabilitydeep_puff :   'clearquartz', 
   inabilitygentnature :  'clearquartz',
   loveopenheart :  'rosequartz', 
   lovedeepconn :   'clearquartz', 
   loveinclarity :  'clearquartz', 
   lovedeep_puff :   'clearquartz', 
   lovegentnature :  'clearquartz',
   concenopenheart :  'rosequartz', 
   concendeepconn :   'clearquartz', 
   conceninclarity :  'amethyst', 
   concendeep_puff :   'clearquartz', 
   concengentnature :  'clearquartz',
   anxopenheart :  'rosequartz', 
   anxdeepconn :   'clearquartz', 
   anxinclarity :  'amethyst', 
   anxdeep_puff :   'clearquartz', 
   anxgentnature :  'clearquartz',
   naopenheart :  'rosequartz', 
   nadeepconn :   'tourmaline', 
   nainclarity :  'amethyst', 
   nadeep_puff :   'jade', 
   nagentnature :  'clearquartz', 
  wrinkles :  'dermaroller', 
   scarring :   'scars', 
   stretch : 'stretchmarks', 
   cellulite :   'cellulites',
   hairloss :   'hairrestoration',
  wrinklesshortface_necksensitive : 'dermaroller' ,
wrinklesshortface_necknormal : 'dermaroller' ,
wrinklesshortface_neckdry : 'dermaroller' ,
wrinklesshortface_neckoily : 'dermaroller' ,
wrinklesshortface_neckcombination : 'dermaroller' ,
wrinklesshorthandssensitive : 'dermaroller' ,
wrinklesshorthandsnormal : 'dermaroller' ,
wrinklesshorthandsdry : 'dermaroller' ,
wrinklesshorthandsoily : 'dermaroller' ,
wrinklesshorthandscombination : 'dermaroller' ,
wrinklesshorttighssensitive : 'dermaroller' ,
wrinklesshorttighsnormal : 'dermaroller' ,
wrinklesshorttighsdry : 'dermaroller' ,
wrinklesshorttighsoily : 'dermaroller' ,
wrinklesshorttighscombination : 'dermaroller' ,
wrinklesshortscalpsensitive : 'dermaroller' ,
wrinklesshortscalnormal : 'dermaroller' ,
wrinklesshortscaldry : 'dermaroller' ,
wrinklesshortscalpoily : 'dermaroller' ,
wrinklesshortscalpcombination : 'dermaroller' ,
wrinklesshortothersensitive : 'dermaroller' ,
wrinklesshortothernormal : 'dermaroller' ,
wrinklesshortotherdry : 'dermaroller' ,
wrinklesshortotheroily : 'dermaroller' ,
wrinklesshortothercombination : 'dermaroller' ,
wrinkleslongface_necksensitive : 'dermaroller' ,
wrinkleslongface_necknormal : 'dermaroller' ,
wrinkleslongface_neckdry : 'dermaroller' ,
wrinkleslongface_neckoily : 'dermaroller' ,
wrinkleslongface_neckcombination : 'dermaroller' ,
wrinkleslonghandssensitive : 'dermaroller' ,
wrinkleslonghandsnormal : 'dermaroller' ,
wrinkleslonghandsdry : 'dermaroller' ,
wrinkleslonghandsoily : 'dermaroller' ,
wrinkleslonghandscombination : 'dermaroller' ,
wrinkleslongtighssensitive : 'dermaroller' ,
wrinkleslongtighsnormal : 'dermaroller' ,
wrinkleslongtighsdry : 'dermaroller' ,
wrinkleslongtighsoily : 'dermaroller' ,
wrinklesslongtighscombination : 'dermaroller' ,
wrinkleslongscalpsensitive : 'dermaroller' ,
wrinkleslongscalpnormal : 'dermaroller' ,
wrinkleslongscalpdry : 'dermaroller' ,
wrinkleslongscalpoily : 'dermaroller' ,
wrinkleslongcalpcombination : 'dermaroller' ,
wrinkleslongtothersensitive : 'dermaroller' ,
wrinkleslongothernormal : 'dermaroller' ,
wrinkleslongotherdry : 'dermaroller' ,
wrinkleslongotheroily : 'dermaroller' ,
wrinkleslongothercombination : 'dermaroller' ,

  
  
};   
  
function getresult2(comp){
  if( pageURL[1] == 'create-by-chakra'){
     $("#mc-embedded-subscribe-form").submit(function() {
  return false;
    });
  	var compkey = comp[0]+comp[1];
    $.each(chak_arr, function(key, value) {
     if(key == compkey){ 
       finalcall(value)
     }
      }); 
  }
    if( pageURL[1] == 'microneedling-quiz'){
       $("#mc-embedded-subscribe-form").submit(function() {
  return false;
    });
  	var compkey = comp[0]+comp[1]+comp[2]+comp[3];
    $.each(microneedling_arr, function(key, value) {
     if(key == compkey){ 
       finalcall(value)
     }
      }); 
  }
   if( pageURL[1] == 'create-by-skin-type'){
   $("#mc-embedded-subscribe-form").submit(function() {
  return false;
    });
  	var compkey = comp[0]+comp[1];
    $.each(skin_arr, function(key, value) {
     if(key == compkey){ 
       finalcall(value)
     }
      });  
  }
   if( pageURL[1] == 'create-by-acupuncture-meridian'){
      $("#mc-embedded-subscribe-form").submit(function() {
  return false;
    });
  	var compkey = comp[0]+comp[1]+comp[2];
    $.each(acupuncture_arr, function(key, value) {
     if(key == compkey){ 
       
       finalcall(value)
     }
      }); 
  }
}
function getresult(){
  list = [];
  $('.customradio.active').each(function () {
     var getval = $(this).data('name');
     list.push(getval);
  });
  getresult2(list);
}
$('.customradio').click(function(){
      $(this).addClass('active').siblings().removeClass('active');
      var getnext_step = $(this).closest('.quizwrap').attr('r_next');
      var getcurrent_step =$(this).closest('.quizwrap').attr('id');
      $('.nextbtn span').attr('rel_show',getnext_step);
      $('.nextbtn span').attr('rel_hide',getcurrent_step);
      $('.nextbtn span').css('display','inline-block');
    	$('.nextbtn').css('display','block');
      if ($(window).width() < 768) {
        $("html, body").animate({
          scrollTop: $('.nextbtn').offset().top -200
        }, 1000);
      }
});
$('.nextbtn span').click(function(){
  $('.nextbtn').css('display','none');
    $('.backbtn span').show();
    $('#'+$(this).attr('rel_hide')+'').hide();
    $('#'+$(this).attr('rel_show')+'').show();
    var getprevt_step = $('#'+$(this).attr('rel_show')+'').attr('r_prev');
    $('.backbtn span').attr('rel_show',getprevt_step);
    if($(this).attr('rel_show') == 'result'){
      $(this).hide();
       getresult();
    }
	$('.quizwrap').removeClass('activequiz');
    $('#'+$(this).attr('rel_show')+'').addClass('activequiz');
  	var getprevstep = $('.quizwrap.activequiz').attr('id');
    $('.backbtn span').attr('rel_hide',getprevstep);
    $(this).attr('rel_hide',$('.quizwrap.activequiz').attr('id'));
    $(this).attr('rel_show', $('.quizwrap.activequiz').attr('r_next'));
 
    if ($(window).width() < 768) {
      $("html, body").animate({
        scrollTop: $('.quizwrap').offset().top
      }, 1000);
  	}
});
  
$('.backbtn span').click(function(){
    $('.nextbtn span').show();
  	if($(this).attr('rel_show') == 'step1' )
    {
      $(this).hide();
    }
    $('#'+$(this).attr('rel_hide')+'.activequiz').hide();
    $('#'+$(this).attr('rel_hide')+'.activequiz').removeClass('activequiz');
    $('#'+$(this).attr('rel_show')+'').addClass('activequiz');
    $('#'+$(this).attr('rel_show')+'').show();
   	$(this).attr('rel_hide',$('.quizwrap.activequiz').attr('id'));
  	$(this).attr('rel_show',$('.quizwrap.activequiz').attr('r_prev'));
  	$('.nextbtn span').attr('rel_show',$('.quizwrap.activequiz').attr('r_next'));
    $('.nextbtn span').attr('rel_hide',$('.quizwrap.activequiz').attr('id'));
});

var g_url ='',p_url='';
function finalcall(result){ 
console.log(result);
  
  /***if(result == 'clearquartz'){g_list='SSxcTG'; g_url = 'https://manage.kmail-lists.com/subscriptions/subscribe?a=UnVze2&g=SSxcTG'}
  else if(result == 'rosequartz'){g_list='QUQNGr'; g_url = 'https://manage.kmail-lists.com/subscriptions/subscribe?a=UnVze2&g=QUQNGr'}
  else if(result == 'amethyst'){g_list='Xb3gSF'; g_url = 'https://manage.kmail-lists.com/subscriptions/subscribe?a=UnVze2&g=Xb3gSF'}
  else if(result == 'jade'){g_list='XHr59U'; g_url = 'https://manage.kmail-lists.com/subscriptions/subscribe?a=UnVze2&g=XHr59U'}
  else if(result == 'tourmaline'){g_list='TkhJPx'; g_url = 'https://manage.kmail-lists.com/subscriptions/subscribe?a=UnVze2&g=TkhJPx'}
  else if(result == 'dermaroller'){g_url = 'https://whitelotus.us19.list-manage.com/subscribe/post?u=54dc8ae4ae4b55dc5a0d58a87&amp;id=c0d535683c'}
***/
 if(result == 'clearquartz'){resPP="clearquartz";g_list="SSxcTG"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}
  else if(result == 'rosequartz'){resPP="rosequartz";g_list="QUQNGr"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}
  else if(result == 'amethyst'){resPP="amethyst";g_list="Xb3gSF"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}
  else if(result == 'jade'){resPP="jade";g_list="XHr59U"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}
  else if(result == 'tourmaline'){resPP="tourmaline";g_list="TkhJPx"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}
  else if(result == 'dermaroller'){resPP="dermaroller";g_list="YsDbE3"; a_list="UnVze2"; g_url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"}

  $('.submitform').click(function(e){  
  // e.preventDefault();
   console.log(" Button clickedbutton ");
  
   var form = new FormData();
form.append("a", "UnVze2");
form.append("g", g_list);
form.append("email", $("#mce-EMAIL").val());
var settings = {
  "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
  "method": "POST",
  "timeout": 0,
  "processData": false,
  "mimeType": "multipart/form-data",
  "contentType": false,
  "data": form
};

$.ajax(settings).done(function (response) {
  console.log(response);
 // console.log(resPP);
   callbackFunction (resPP);
});
    function callbackFunction (resp) {
  console.log(" Working");
   // if (resp.result === 'success') {
         if(resPP == 'clearquartz'){p_url = '/pages/clear-quartz-crystal-facial'}
          else if(resPP == 'rosequartz'){p_url = '/pages/rose-quartz-crystal-facial'}
          else if(resPP == 'amethyst'){p_url = '/pages/amethyst-crystal-facial'}
          else if(resPP == 'jade'){p_url = '/pages/jade-crystal-facial'}
          else if(resPP == 'tourmaline'){p_url = '/pages/tourmaline-crystal-facial'}
      else if(resPP == 'dermaroller'){p_url = '/pages/dermaroller-kit-for-you'}
      else if(resPP == 'scar'){p_url = '/pages/scar-dermaroller'}
      else if(resPP == 'stretchmarks'){p_url = '/pages/microneedling-stretch-marks'}
      else if(resPP == 'cellulites'){p_url = '/pages/microneedling-stretch-marks'}
      else if(resPP == 'hairrestoration'){p_url = '/pages/hair-regrowth'}
      
            if(p_url){
                window.location.href = p_url;
            }
    	//}
     // else{console.log(resp.result); }
	}
  
  });

}
});

$(".heading_click a[href^='#']").on("click", function(e) {
  e.preventDefault();
  $("html, body").animate({
    scrollTop: $($(this).attr("href")).offset().top
  }, 1000);
}); 
 
$(".learnmore.ntlast").on("click", function(e) {
  e.preventDefault();
  $("html, body").animate({
    scrollTop: $('.content.last').offset().top
  }, 1000);
});
